import React, { ChangeEvent } from "react"
import styled from "styled-components"
import { ImageInput } from "../../../../../../../../components/parts/image-input"
import { convertEditorContentFromContent } from "../../../../../../../../libs/converter/convert-editor-episode-from-episode"
import { ContentWithUser } from "../../../../../../../../types/data-types"
import { ThrowError } from "../../../../../../../../error/error"
import { CreateContent } from "../../../../../../../../libs/create-content"
import {
  ImageUpload,
  InputImageErrorCheck,
  MAXIMUM_DIMENSION,
} from "../../../../../../../../libs/input-image-file"
import { ImageTransform } from "../../../../../../../../libs/input-image-file/image-transform-ifneeded"
import { Types } from "../../../../../../../../rpcs/dist/EpisodeRPC"
import { ContentActionDispatcher } from "../../../../../../actiondispacher/content-action-dispacher"
import { EDIT_TYPE, IEditorContent } from "../../../../../../types"
import { addCommands, AddType } from "./data"

export interface IMenuOptions {
  survey: boolean
}

interface IProps {
  content: IEditorContent
  contents: IEditorContent[]
  actions: ContentActionDispatcher
  options: IMenuOptions
}

export class Menu extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)
    this.insert = this.insert.bind(this)
    this.shallowRemove = this.shallowRemove.bind(this)
    this.onClick = this.onClick.bind(this)
    this.showMoveUp = this.showMoveUp.bind(this)
    this.showMoveDown = this.showMoveDown.bind(this)
    this.prevContent = this.prevContent.bind(this)
    this.isLastContent = this.isLastContent.bind(this)
    this.onSelectImage = this.onSelectImage.bind(this)
  }

  public render() {
    return addCommands.map((command, i) => {
      if (command.type === AddType.DOWN && !this.showMoveDown()) {
        return null
      }

      if (command.type === AddType.UP && !this.showMoveUp()) {
        return null
      }

      if (command.type === AddType.IMAGE) {
        return (
          <ImageInput key={i} onChange={this.onSelectImage}>
            <StyledImg src={command.img} />
          </ImageInput>
        )
      }

      if (command.type === AddType.SURVEY && !this.props.options.survey) {
        return null
      }

      const onClick = () => this.onClick(command.type)
      return <StyledImg key={i} src={command.img} onClick={onClick} />
    })
  }

  private async onSelectImage({ target }: ChangeEvent<HTMLInputElement>) {
    await InputImageErrorCheck(target.files)
      .then(file => ImageTransform(file, MAXIMUM_DIMENSION))
      .then(base64image => ImageUpload(base64image))
      .then(images => {
        const content = CreateContent.Annotation(`${images.url.large}`)
        this.insert(content, EDIT_TYPE.SHOW)
      })
      .catch(ThrowError)
  }

  private onClick(type: AddType) {
    switch (type) {
      case AddType.ANNOTATION:
        return this.insert(CreateContent.Annotation(""))
      case AddType.HEADLINE:
        return this.insert(CreateContent.Headline(""))
      case AddType.QUOTATION:
        return this.insert(CreateContent.Quotation(""))
      case AddType.SURVEY:
        return this.props.actions.clickMenuSurvey(this.props.content.uuid)
      case AddType.DOWN:
        return this.props.actions.clickMenuMoveDownContent(
          this.props.content.uuid,
        )
      case AddType.UP:
        return this.props.actions.clickMenuMoveUpContent(
          this.props.content.uuid,
        )
      case AddType.REMOVE:
        return this.shallowRemove()
      case AddType.CLOSE:
        return this.props.actions.clickMenuClose()
    }
  }

  private insert(
    content: ContentWithUser,
    editType: EDIT_TYPE = EDIT_TYPE.EDIT,
  ) {
    const insertEditorContent = convertEditorContentFromContent(content)
    insertEditorContent._editMetaData.type = editType
    this.props.actions.insertContent(
      insertEditorContent,
      this.props.content.uuid,
    )
  }

  private shallowRemove() {
    this.props.actions.clickRemoveContent(this.props.content.uuid)
  }

  private prevContent() {
    const index = this.props.contents.findIndex(
      c => c.uuid === this.props.content.uuid,
    )
    if (index > 0) {
      return this.props.contents[index - 1]
    }
    return null
  }

  private isLastContent() {
    return (
      this.props.contents[this.props.contents.length - 1].uuid ===
      this.props.content.uuid
    )
  }

  private showMoveUp(): boolean {
    const prevContent = this.prevContent()
    if (this.props.content.type === Types.Introduction) {
      return false
    }
    if (prevContent === null) {
      return false
    }
    if (prevContent.type === Types.Introduction) {
      return false
    }
    return true
  }

  private showMoveDown(): boolean {
    if (this.isLastContent()) {
      return false
    }
    if (this.props.content.type === Types.Introduction) {
      return false
    }
    return true
  }
}

const StyledImg = styled.img`
  width: 55px;
  height: 55px;
  cursor: pointer;
`
